import { axiosPublic, axiosClient } from 'lib/axiosClient';
import cookies from 'utils/cookies';

export const login = credentials => {
	// return axiosPublic.post('/auth/login', credentials);
	// return axiosPublic.get('/auth/login/google')
	window.open(`${process.env.REACT_APP_API_URL}/auth/login/google`, '_self');
};

export const logout = () => {
	const refreshToken = cookies.getRefreshToken() || '';
	return axiosPublic.post('/auth/logout', { refresh_token: refreshToken });
};

export const getToken = () => {
	const refreshToken = cookies.getRefreshToken() || '';

	return axiosPublic.post('/auth/refresh', {
		refresh_token: refreshToken,
	});
};

export const getUserInfo = config => {
	return axiosClient.get(`/auth/userInfo?token=${config.refresh_token}`);
};
